module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "package-down"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "title-name"
  }, [_c('div', {
    class: [_vm.item.title.release ? 'release' : '']
  }, [_vm._v(_vm._s(_vm.item.title.cname)), _c('strong', [_vm._v(_vm._s(_vm.item.title.version))])])]), _vm._v(" "), _c('div', {
    staticClass: "title-desc"
  }, [_vm._v(_vm._s(_vm.item.title.desc))])]), _vm._v(" "), _c('div', {
    staticClass: "basic"
  }, [_c('div', {
    staticClass: "basic-head"
  }, [_c('div', {
    staticClass: "basic-head-tag"
  }), _vm._v(" "), _c('div', {
    staticClass: "basic-head-name"
  }, [_vm._v(_vm._s(_vm.item.basic.name))]), _vm._v(" "), (_vm.isBinary) ? _c('div', {
    staticClass: "basic-head-item"
  }, [_vm._v("大小：" + _vm._s(_vm.item.basic.size))]) : _vm._e(), _vm._v(" "), (_vm.isBinary) ? _c('div', {
    staticClass: "basic-head-item"
  }, [_vm._v("MD5：" + _vm._s(_vm.item.basic.md5))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "basic-head-desc"
  }, [_vm._v(_vm._s(_vm.item.basic.desc))]), _vm._v(" "), _c('div', {
    staticClass: "basic-head-log",
    on: {
      "click": function($event) {
        return _vm.jumpPage(_vm.item.basic.extra_info.log)
      }
    }
  }, [_vm._v("，更新日志"), _c('i', {
    staticClass: "icon-cc-jump-link-2",
    staticStyle: {
      "color": "#3A84FF",
      "font-size": "14px",
      "margin-left": "8px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-head-btn"
  }, [(_vm.type === 'binary') ? [_c('div', {
    staticClass: "btn basic-head-download",
    on: {
      "click": function($event) {
        return _vm.basicJumpPage(_vm.item.basic, '立即下载')
      }
    }
  }, [_vm._v("立即下载")]), _vm._v(" "), _c('div', {
    staticClass: "btn basic-head-install",
    on: {
      "click": function($event) {
        return _vm.basicJumpPage(_vm.item.basic, '安装指引')
      }
    }
  }, [_vm._v("安装指引")])] : _c('div', {
    staticClass: "btn combo-deploy",
    on: {
      "click": function($event) {
        return _vm.basicJumpPage(_vm.item.basic, '前往部署')
      }
    }
  }, [_vm._v("前往部署")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "basic-content"
  }, [_c('contentVue', {
    attrs: {
      "list": _vm.item.basic.children,
      "is-basic": true
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "annotation"
  }, [_vm._v("以下套餐的资源配置建议，是指在基础套餐最少资源配置之外的另需资源；如有大规模生产投入及高可用规划，需要根据实际使用情况进行扩容。")]), _vm._v(" "), _c('div', {
    staticClass: "combos"
  }, _vm._l((_vm.item.combos), function(combo) {
    return _c('div', {
      key: combo.name,
      staticClass: "combo-item"
    }, [_c('div', {
      staticClass: "combo-name"
    }, [_vm._v("\n                " + _vm._s(combo.name) + "\n                "), (combo.name === '容器管理套餐' && _vm.type === 'containerize') ? _c('img', {
      staticClass: "combo-tag",
      attrs: {
        "src": require("../../images/downloads/must.png"),
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "combo-tag",
      attrs: {
        "src": require("../../images/downloads/optional.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "combo-desc"
    }, [(_vm.isBinary) ? _c('div', {
      staticClass: "combo-desc-item"
    }, [_vm._v("大小：" + _vm._s(combo.extra_info.size))]) : _vm._e(), _vm._v(" "), (_vm.isBinary) ? _c('div', {
      staticClass: "combo-desc-item"
    }, [_vm._v("MD5：" + _vm._s(combo.extra_info.md5))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "combo-desc-item"
    }, [_vm._v(_vm._s(combo.desc) + "，更新日志"), _c('i', {
      staticClass: "icon-cc-jump-link-2 link",
      staticStyle: {
        "color": "#3A84FF",
        "font-size": "14px",
        "margin-left": "8px"
      },
      on: {
        "click": function($event) {
          return _vm.jumpPage(combo.extra_info.log)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "combo-ctr"
    }, [_c('contentVue', {
      ref: combo.name,
      refInFor: true,
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "list": combo.children,
        "comboType": combo.name === '容器管理套餐'
      },
      on: {
        "recordUserDownload": _vm.recordUserDownload,
        "containerDeployValidate": _vm.containerDeployValidate
      }
    })], 1)])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "va"
  }, [_c('div', {
    staticClass: "va-icon r1"
  }), _vm._v(" "), _c('div', {
    staticClass: "va-icon r1 rr"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 15px"
    }
  }, [_vm._v("增值套餐")]), _vm._v(" "), _c('div', {
    staticClass: "va-icon r2 ll"
  }), _vm._v(" "), _c('div', {
    staticClass: "va-icon r2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-91bae0d0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/downloads/packageDown.vue
// module id = nX14
// module chunks = 15